export default {
    edge_tensor_video_review_title: "Video review",
    edge_tensor_video_review_video: "Video",
    edge_tensor_video_review_notes: "Notes",
    edge_tensor_video_review_status: "Status",
    edge_tensor_video_review_warning_notes: "Notes must be at least 3 characters long",
    edge_tensor_video_review_success_messages: "Video review saved successfully",
    edge_tensor_video_review_error_messages: "Error saving video review",
    edge_tensor_video_review_unreviewed: "Unreviewed",
    edge_tensor_video_review_reviewed: "Reviewed",
    edge_tensor_video_review_false_positive: "False Positive",
    edge_tensor_video_review_accepted: "Accepted",
    edge_tensor_video_review_disputed: "Disputed",
    edge_tensor_video_review: "Review",
    edge_tensor_video_review_video_results: "AI Review",
    edge_tensor_video_review_video_result: "Video Result",
    edge_tensor_video_review_event_video: "Video Event"
};